const makeCompany = company => {
  if (!company) {
    return {};
  }
  return {
    value: company.currentName + company.uri,
    label: company.currentName,
    uri: company.uri,
    uid: company.uid,
  };
};

export default makeCompany;
